import { makeStyles } from "@fluentui/react";
export const useStyles = makeStyles((theme) => ({
  removeButtonContainer: {
    width: 30
  },
  inputsContainer: {
    flex: 1
  }
}));